import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-tous-facture',
  templateUrl: './tous-facture.component.html',
  styleUrls: ['./tous-facture.component.scss']
})
export class TousFactureComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterFactureByStatus('Tous');
    }

}
